import { CreateFocusCss, isTouchScreen } from '../../../styles'
import type { Tokens } from '../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config

  return {
    default: {
      input: {
        ...CreateFocusCss(
          {
            height: '22px',
            insetInlineStart: '1px',
            top: '9px',
            width: '22px',
          } as const,
          (psuedoClass) => `${psuedoClass} + label > span::after`,
        ),
      },

      label: {
        minHeight: '32px',
        paddingTop: '8px',
        paddingBottom: '8px',

        [isTouchScreen]: {
          paddingTop: '12px',
          paddingBottom: '12px',
        },

        '::before': {
          borderWidth: '2px',
          margin: '2px',
        },

        '&::after': {
          background: '0 0',
          insetInlineStart: '6px',
          top: '16px',

          [isTouchScreen]: {
            top: '20px',
          },
        },

        '& > span': {
          '&::before': {
            height: '26px',
            insetInlineStart: '-1px',
            width: '26px',
            top: '7px',
            transitionDuration: '0.1s',
          },
        },

        '&:hover': {
          '&::before': {
            borderColor: tokens.formControlBorderColorHover,
          },

          '& > span': {
            '&::before': {
              borderColor: tokens.selectionControl.defaultHoverShadowColor,
              borderWidth: '7px',
              content: '""',
              height: '32px',
              insetInlineStart: '-4px',
              top: '4px',
              width: '32px',

              [isTouchScreen]: {
                top: '8px',
              },
            },
          },
        },

        'input:checked + &::before, input:indeterminate + &::before': {
          backgroundColor: tokens.formControlBgColorSelected,
          borderColor: tokens.formControlBorderColorSelected,
        },

        'input:checked + &::after, input:indeterminate + &::after': {
          borderColor: tokens.formControlBgColorDefault,
        },

        'input:checked:hover + &::before, input:indeterminate:hover + &::before':
          {
            backgroundColor: tokens.selectionControl.selectedHoverFillColor,
            borderColor: tokens.selectionControl.selectedHoverFillColor,
          },

        'input:checked:active + &::before, input:indeterminate:active + &::before':
          {
            backgroundColor: tokens.formControlBgColorSelectedActive,
            borderColor: tokens.formControlBorderColorSelectedActive,
          },

        'input:checked:disabled + &::before, input:checked:disabled + &::after':
          {
            backgroundColor: tokens.formControlBgColorSelected,
          },

        'input:active + &::before': {
          borderColor: tokens.formControlBorderColorHover,
        },

        'input:indeterminate + &::after': {
          insetInlineStart: '5px',
          top: '19px',
          width: '14px',

          [isTouchScreen]: {
            top: '22px',
          },
        },
      },

      text: {
        paddingInlineStart: '8px',
      },

      description: {
        marginBlock: '-4px 0',
        marginInline: '32px 0',
      },

      error: {
        marginBlock: '0',
        marginInline: '32px 0',
      },

      descriptionError: {
        marginBlock: '8px 0',
      },
    },

    beforeText: {
      icon: {
        marginInlineEnd: '8px',
      },
    },

    invalid: {
      label: {
        '&::before': {
          borderColor: `${tokens.formElementInputBorderColorError} !important`,
        },

        'input:checked + &::before, input:indeterminate + &::before': {
          backgroundColor: `${tokens.formElementInputBorderColorError} !important`,
        },

        'input:checked + &::after, input:indeterminate + &::after': {
          borderColor: tokens.formControlBgColorDefault,
        },
      },
    },
  } as const
}
